import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { MaskedLines, Reveal, Eyebrow } from "@/components/site/Motion";
import { NewsCard } from "@/components/news/NewsCard";

export default function News() {
  const [items, setItems] = useState(null);
  const [cat, setCat] = useState("Alla");

  useEffect(() => {
    api.get("/news")
      .then((r) => setItems(Array.isArray(r.data) ? r.data : []))
      .catch(() => setItems([]));
  }, []);

  const cats = useMemo(() => ["Alla", ...new Set((items || []).map((n) => n.category).filter(Boolean))], [items]);
  const shown = (items || []).filter((n) => cat === "Alla" || n.category === cat);
  const [lead, ...rest] = shown;

  return (
    <div data-testid="news-page">
      <section className="-mt-20 pt-32 lg:pt-40 pb-12 grid-lines">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <Eyebrow>Nyheter</Eyebrow>
          <MaskedLines testId="news-page-title" className="font-display font-bold tracking-[-0.035em] leading-[0.95] text-5xl sm:text-6xl lg:text-7xl mt-6" lines={["Nytt från", "Redoc."]} />
          <div className="mt-10 flex flex-wrap gap-2" data-testid="news-category-filter">
            {cats.map((c) => (
              <button key={c} onClick={() => setCat(c)} data-testid={`news-filter-${c}`} className={`rounded-full px-5 py-2 text-sm font-semibold border transition-colors ${cat === c ? "bg-[#070B2E] text-white border-[#070B2E]" : "bg-white border-[#D8D7CE] text-[#1C2150] hover:border-[#070B2E]"}`}>{c}</button>
            ))}
          </div>
        </div>
      </section>
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-28">
        {items === null && <p className="text-[#3A3F5C]">Laddar nyheter…</p>}
        {items !== null && shown.length === 0 && <p className="text-[#3A3F5C]" data-testid="news-empty">Inga nyheter publicerade ännu.</p>}
        {lead && (
          <Reveal className="mb-16">
            <div className="grid lg:grid-cols-12 gap-8" data-testid="news-lead">
              <div className="lg:col-span-12"><NewsCardLead item={lead} /></div>
            </div>
          </Reveal>
        )}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
          {rest.map((n, i) => <Reveal key={n.id} delay={(i % 3) * 0.08} className="h-full"><NewsCard item={n} /></Reveal>)}
        </div>
      </section>
    </div>
  );
}

const NewsCardLead = ({ item }) => (
  <div className="[&_a]:lg:grid [&_a]:lg:grid-cols-12 [&_a]:lg:gap-10 [&_a>div:first-child]:lg:col-span-7 [&_a>div:first-child]:lg:aspect-[16/10] [&_a>div:last-child]:lg:col-span-5 [&_a>div:last-child]:lg:justify-center [&_h3]:lg:text-4xl">
    <NewsCard item={item} />
  </div>
);
